import React, {Component} from "react"
import PropTypes from "prop-types"
import FileUpload from "../../molecules/FileUpload"
import Icon from "../../atoms/Icon"
import Button from "../../atoms/Button"

class ManageAgendaItems extends Component {
  render() {
    const that = this
    const {dayId, items, uploadingMedia} = this.props

    const addItem = () => {
      this.props.addItem(dayId)
    }

    return (
      <div className="ManageAgendaItems">
        <h4>Agenda Item</h4>
        {items &&
          Object.keys(items).map(itemId => {
            const agendaItem = items[itemId]

            const updateItem = ev => {
              that.props.updateItem(dayId, itemId, {
                [ev.target.name]: ev.target.value,
              })
            }

            const removeItem = () => {
              that.props.removeItem(dayId, itemId)
            }

            const updateMedia = file => {
              this.props.uploadMedia(itemId, file.getFile()).then(val => {
                this.props.updateItem(dayId, itemId, {
                  media: val,
                })
              })
            }

            if (agendaItem === null) return null

            return (
              <div className="AgendaItem" key={itemId}>
                <Button type="delete" onClick={removeItem}>
                  <Icon icon="trash-empty" />
                </Button>
                <div>
                  <label> Title: </label>
                  <input
                    type="text"
                    name="title"
                    value={agendaItem.title || ""}
                    onChange={updateItem}
                  />
                </div>
                <div>
                  <label> Location: </label>
                  <input
                    type="text"
                    name="location"
                    value={agendaItem.location || ""}
                    onChange={updateItem}
                  />
                </div>
                <div>
                  <label> Start Time: </label>
                  <input
                    type="text"
                    name="startTime"
                    value={agendaItem.startTime || ""}
                    onChange={updateItem}
                  />
                </div>
                <div>
                  <label> End Time: </label>
                  <input
                    type="text"
                    name="endTime"
                    value={agendaItem.endTime || ""}
                    onChange={updateItem}
                  />
                </div>
                <div>
                  <label>Description:</label>
                  <textarea
                    type="text"
                    name="description"
                    value={agendaItem.description || ""}
                    onChange={updateItem}
                    rows="3"
                  />
                </div>
                <div className="image-upload">
                  {uploadingMedia.indexOf(itemId) > -1 &&
                    <p> Uploading ... </p>}
                  <FileUpload
                    name="media"
                    value={agendaItem.media}
                    onChange={updateMedia}
                  />
                </div>
                <hr />
              </div>
            )
          })}
        <div className="AddAgendaItem">
          <Button onClick={addItem}>
            <Icon icon="plus" /> Add New Agenda Item
          </Button>
        </div>
      </div>
    )
  }
}

ManageAgendaItems.defaultProps = {
  items: {},
  uploadingMedia: [],
}

ManageAgendaItems.propTypes = {
  dayId: PropTypes.string.isRequired,
  items: PropTypes.object.isRequired,
  uploadingMedia: PropTypes.arrayOf(PropTypes.string).isRequired,
  addItem: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
  updateItem: PropTypes.func.isRequired,
  uploadMedia: PropTypes.func.isRequired,
}

export default ManageAgendaItems



// WEBPACK FOOTER //
// ./src/component/organisms/ManageAgenda/ManageAgendaItems.js